import { render, staticRenderFns } from "./FilesSender.vue?vue&type=template&id=5d73eccc"
import script from "./FilesSender.vue?vue&type=script&lang=js"
export * from "./FilesSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports